/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import { scrollToAnchor } from "../../../../theme/commonStyle";

const attorneySectionStyle = {
  scrollToAnchor,
};

export default attorneySectionStyle;
